/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_card__carousel__aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Bildkarussell für`
};

const en_poi_card__carousel__aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Image carousel for`
};

const es_poi_card__carousel__aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Carrusel de imágenes para`
};

const fr_poi_card__carousel__aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Carrousel d'image pour`
};

const it_poi_card__carousel__aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Carosello di immagini per`
};

const nl_poi_card__carousel__aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Afbeeldingencarrousel voor`
};

const pt_poi_card__carousel__aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Carrossel de imagens para`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__aria_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_card__carousel__aria_label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_card__carousel__aria_label", locale)
	if (locale === "de") return de_poi_card__carousel__aria_label(inputs)
	if (locale === "en") return en_poi_card__carousel__aria_label(inputs)
	if (locale === "es") return es_poi_card__carousel__aria_label(inputs)
	if (locale === "fr") return fr_poi_card__carousel__aria_label(inputs)
	if (locale === "it") return it_poi_card__carousel__aria_label(inputs)
	if (locale === "nl") return nl_poi_card__carousel__aria_label(inputs)
	return pt_poi_card__carousel__aria_label(inputs)
};